import Mock from 'mockjs'
import loginAPI from './login'

// 登录相关
Mock.mock(/\/api\/v1\/uaa\/login/, 'post', loginAPI.loginByUsername)
Mock.mock(/\/api\/v1\/uaa\/logout/, 'get', loginAPI.logout)
Mock.mock(/\/api\/v1\/common\/secret/, 'post', loginAPI.encryptionPwd)
Mock.mock(/\/api\/v1\/common\/secret\/symmetric/, 'get', loginAPI.encryptionPwd)
Mock.mock(/\/api\/v1\/authentication\/user/, 'get', loginAPI.getCurrent)
Mock.mock(/\/api\/v1\/uaa\/getNcAppKey/, 'get', loginAPI.getNcAppKey)
// Mock.mock(/\/api\/v1\/uaa\/password\/sendForgetEmail/, 'post', loginAPI.sendForgetEmail)
Mock.mock(/\/api\/v1\/common\/sms/, 'get', loginAPI.sendForgetMobile)
Mock.mock(/\/api\/v1\/uaa\/password\/security-code\/verify/, 'post', loginAPI.checkCodeForPassword)
// Mock.mock(/\/api\/v1\/uaa\/password\/reset/, 'post', loginAPI.resetPasswordAfterCheckCode)
Mock.mock(/\/custom\/anonymous\/domain\.json/, 'get', loginAPI.fetchDomain)
Mock.mock(/\/api\/v1\/common\/user\/password\/pattern/, 'post', loginAPI.getPasswordPattern)

export default Mock



// WEBPACK FOOTER //
// ./src/mock/index.js